/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
import {
    AsyncResult,
    callActionOrExecute,
    DataServiceQuery,
    IContext,
    IDataServiceRequest,
    IQueryResultSettings,
    // @ts-ignore -- Unused import
    NullResult
} from '@msdyn365-commerce/retail-proxy';
// @ts-ignore -- Unused import
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
// @ts-ignore -- Unused import
import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import * as DataServiceEntities from './DataServiceEntities.g';

function fraudProtectionRiskScoreQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function fraudProtectionRiskScoreInput(request: DataServiceEntities.IFraudProtectionRequest): IDataServiceRequest {
    const query = fraudProtectionRiskScoreQuery();
    return query.createDataServiceRequestForOperation(
        'FraudProtectionRiskScore',
        true,
        DataServiceEntities.FraudProtectionResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IFraudProtectionResponse' },
        {
            request: request
        }
    );
}

export function fraudProtectionRiskScoreAsync(
    context: IContext,
    request: DataServiceEntities.IFraudProtectionRequest
): AsyncResult<DataServiceEntities.IFraudProtectionResponse> {
    const dataServiceRequest = fraudProtectionRiskScoreInput(request);
    return callActionOrExecute<DataServiceEntities.IFraudProtectionResponse>(dataServiceRequest, context.callerContext);
}

function getItemDimensionsQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getItemDimensionsInput(queryResultSettings: IQueryResultSettings, itemIds: string[]): IDataServiceRequest {
    const query = getItemDimensionsQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetItemDimensions',
        true,
        DataServiceEntities.ItemDataExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IItemData' },
        {
            itemIds: itemIds
        }
    );
}

export function getItemDimensionsAsync(context: IContext, itemIds: string[]): AsyncResult<DataServiceEntities.IItemData[]> {
    const request = getItemDimensionsInput(context.queryResultSettings || {}, itemIds);
    return callActionOrExecute<DataServiceEntities.IItemData[]>(request, context.callerContext);
}

function getItemTransportationCodesQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getItemTransportationCodesInput(queryResultSettings: IQueryResultSettings, productIds: number[]): IDataServiceRequest {
    const query = getItemTransportationCodesQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetItemTransportationCodes',
        true,
        DataServiceEntities.ProductTransportationCodeExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IProductTransportationCode' },
        {
            productIds: productIds
        }
    );
}

export function getItemTransportationCodesAsync(
    context: IContext,
    productIds: number[]
): AsyncResult<DataServiceEntities.IProductTransportationCode[]> {
    const request = getItemTransportationCodesInput(context.queryResultSettings || {}, productIds);
    return callActionOrExecute<DataServiceEntities.IProductTransportationCode[]>(request, context.callerContext);
}

function recaptchaVerificationQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function recaptchaVerificationInput(response: string, remoteIp: string): IDataServiceRequest {
    const query = recaptchaVerificationQuery();
    return query.createDataServiceRequestForOperation(
        'RecaptchaVerification',
        true,
        DataServiceEntities.RecaptchaVerificationResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IRecaptchaVerificationResponse' },
        {
            response: response,
            remoteIp: remoteIp
        }
    );
}

export function recaptchaVerificationAsync(
    context: IContext,
    response: string,
    remoteIp: string
): AsyncResult<DataServiceEntities.IRecaptchaVerificationResponse> {
    const request = recaptchaVerificationInput(response, remoteIp);
    return callActionOrExecute<DataServiceEntities.IRecaptchaVerificationResponse>(request, context.callerContext);
}

function nSS_UpdateSalesOrderApprovalStatusQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function nSS_UpdateSalesOrderApprovalStatusInput(
    salesOrderId: string,
    approvalStatus: string,
    rejectComments: string
): IDataServiceRequest {
    const query = nSS_UpdateSalesOrderApprovalStatusQuery();
    return query.createDataServiceRequestForOperation(
        'NSS_UpdateSalesOrderApprovalStatus',
        true,
        DataServiceEntities.UpdateSalesOrderApprovalStatusResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IUpdateSalesOrderApprovalStatusResponse' },
        {
            salesOrderId: salesOrderId,
            approvalStatus: approvalStatus,
            rejectComments: rejectComments
        }
    );
}

export function nSS_UpdateSalesOrderApprovalStatusAsync(
    context: IContext,
    salesOrderId: string,
    approvalStatus: string,
    rejectComments: string
): AsyncResult<DataServiceEntities.IUpdateSalesOrderApprovalStatusResponse> {
    const request = nSS_UpdateSalesOrderApprovalStatusInput(salesOrderId, approvalStatus, rejectComments);
    return callActionOrExecute<DataServiceEntities.IUpdateSalesOrderApprovalStatusResponse>(request, context.callerContext);
}

// @ts-ignore
function cCHLogsQuery(replicationCounter?: number): DataServiceQuery {
    const key = replicationCounter ? { ReplicationCounter: replicationCounter } : null;
    return new DataServiceQuery('CCHLogs', 'CCHLog', DataServiceEntities.CCHLogExtensionClass, key);
}

export function createGetCCHLogsInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = cCHLogsQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetCCHLogs',
        true,
        DataServiceEntities.CCHLogExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.ICCHLog' },
        {}
    );
}

export function getCCHLogsAsync(context: IContext): AsyncResult<DataServiceEntities.ICCHLog[]> {
    const request = createGetCCHLogsInput(context.queryResultSettings || {});
    return callActionOrExecute<DataServiceEntities.ICCHLog[]>(request, context.callerContext);
}
